import { Editor } from '@tiptap/core'
import { useCallback } from 'react'
import { LinkType } from '../type/link-type'

export const useToolbarCommands = (editor: Editor) => {
  const onBold = useCallback(
    () => editor.chain().focus().toggleBold().run(),
    [editor],
  )
  const onItalic = useCallback(
    () => editor.chain().focus().toggleItalic().run(),
    [editor],
  )
  const onStrike = useCallback(
    () => editor.chain().focus().toggleStrike().run(),
    [editor],
  )
  const onUnderline = useCallback(
    () => editor.chain().focus().toggleUnderline().run(),
    [editor],
  )
  const onSetTextColor = useCallback(
    // @TODO: focus call interferes with "close on outside click" popover feature
    (color: string) => editor.chain().focus().setColor(color).run(),
    [editor],
  )

  const onSetHeaderOne = useCallback(
    () => editor.chain().focus().setNode('heading', { level: 1 }).run(),
    [editor],
  )

  const onSetHeaderTwo = useCallback(
    () => editor.chain().focus().setNode('heading', { level: 2 }).run(),
    [editor],
  )

  const onSetHeaderThree = useCallback(
    () => editor.chain().focus().setNode('heading', { level: 3 }).run(),
    [editor],
  )

  const onSetHeaderFour = useCallback(
    () => editor.chain().focus().setNode('heading', { level: 4 }).run(),
    [editor],
  )

  const onSetHeaderFive = useCallback(
    () => editor.chain().focus().setNode('heading', { level: 5 }).run(),
    [editor],
  )

  const onSetHeaderSix = useCallback(
    () => editor.chain().focus().setNode('heading', { level: 6 }).run(),
    [editor],
  )
  const onSetLink = useCallback(
    (link: LinkType) => {
      const { empty } = editor.state.selection
      const attrs = editor.getAttributes('link')

      if (attrs.href && empty) {
        editor
          .chain()
          .extendMarkRange('link')
          .setLink({
            href: link.href as string,
            target: link.target || '',
            rel: link.rel,
            popupid: link.popupid,
          })
          .run()
      } else {
        editor
          .chain()
          .focus()
          .setLink({
            href: link.href as string,
            target: link.target || '',
            rel: link.rel,
            popupid: link.popupid,
          })
          .run()
      }
    },
    [editor],
  )

  const onUnsetLink = useCallback(() => {
    const { empty } = editor.state.selection
    const attrs = editor.getAttributes('link')

    if (attrs.href && empty) {
      editor.chain().extendMarkRange('link').unsetLink().run()
    } else {
      editor.chain().focus().unsetLink().run()
    }
  }, [editor])
  return {
    onBold,
    onItalic,
    onUnderline,
    onStrike,
    onSetTextColor,
    onSetLink,
    onUnsetLink,
    onSetHeaderOne,
    onSetHeaderTwo,
    onSetHeaderThree,
    onSetHeaderFour,
    onSetHeaderFive,
    onSetHeaderSix,
  }
}
